import { PRICE_RECORD as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    refreshBtn: false,
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'left',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    labelPosition: 'top',
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      {
        label: LABELS.priceInformationNumber,
        prop: 'priceRecordNumber',
        search: true,
        overHidden: true
      },
      {
        label: LABELS.materialNumber,
        prop: 'materialNumber',
        search: true,
        overHidden: true
        // supplierName
      },
      {
        label: LABELS.materialName,
        prop: 'materialDesc',
        search: true,
        overHidden: true
        // supplierName
      },
      {
        label: LABELS.supplier,
        prop: 'toElsAccount',
        search: true,
        overHidden: true
        // supplierName
      }
    ]
  }
};
